import { useSearchParams } from "react-router-dom"

import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationNext,
  PaginationPrevious,
} from "@/components/ui/pagination"
type AppPaginationWithoutTotalProps = {
  pagination: {
    hasNext: boolean
    currentPage: number
    tab: string
  }
  startPage?: number
}
export const AppPaginationWithoutTotal: React.FC<
  AppPaginationWithoutTotalProps
> = ({
  pagination,
  startPage = 0,
}: AppPaginationWithoutTotalProps) => {
  const [searchParams] = useSearchParams()
  const isNextDisabled = !pagination?.hasNext
  const adjustedCurrentPage = Math.max(
    1,
    pagination.currentPage - startPage + 1
  )
  const isFirstPage = adjustedCurrentPage <= 1
  const createPageURL = (pageNumber: number) => {
    const params = new URLSearchParams(searchParams)
    const adjustedPageNumber = pageNumber + startPage - 1
    if (adjustedPageNumber === startPage) {
      params.delete("page")
    } else {
      params.set("page", adjustedPageNumber.toString())
    }
    const qs = params.toString()
    return qs ? `?${qs}` : "?"
  }
  const prevHref = createPageURL(
    Math.max(adjustedCurrentPage - 1, 1)
  )
  const nextHref = createPageURL(adjustedCurrentPage + 1)
  const blockIfDisabled: React.MouseEventHandler<
    HTMLAnchorElement
  > = (e) => {
    e.preventDefault()
    e.stopPropagation()
  }
  return (
    <div className="mt-4 flex w-full items-center justify-between gap-4 max-sm:flex-col">
      <p
        className="text-sm text-muted-foreground"
        aria-live="polite"
      >
        Página{" "}
        <span className="font-medium text-foreground">
          {adjustedCurrentPage}
        </span>
      </p>
      <Pagination className="mx-0 w-auto">
        <PaginationContent>
          <PaginationItem>
            <PaginationPrevious
              to={prevHref}
              aria-label="Página anterior"
              aria-disabled={isFirstPage}
              tabIndex={isFirstPage ? -1 : 0}
              onClick={
                isFirstPage ? blockIfDisabled : undefined
              }
              className={
                isFirstPage
                  ? "pointer-events-none select-none opacity-50"
                  : "cursor-pointer"
              }
            />
          </PaginationItem>
          <PaginationItem>
            <PaginationNext
              to={nextHref}
              aria-label="Próxima página"
              aria-disabled={isNextDisabled}
              tabIndex={isNextDisabled ? -1 : 0}
              onClick={
                isNextDisabled ? blockIfDisabled : undefined
              }
              className={
                isNextDisabled
                  ? "pointer-events-none select-none opacity-50"
                  : "cursor-pointer"
              }
            />
          </PaginationItem>
        </PaginationContent>
      </Pagination>
    </div>
  )
}
